export default "/app/global-wrapper-client/static/70470c15e2685049c45c66d0aae757a6.woff2";